module.exports = __webpack_public_path__ + "img/aware.51f625b5.png";